import {
  readFromLocalStorage,
  writeToLocalStorage,
} from '@/lib/local-storage/local-storage';
import { DEFAULT_SESSION_VALUES, SESSION_KEY } from './constants';
import type { SessionValues } from './types';

export function setSessionValues(
  data: Partial<Omit<SessionValues, 'isExpired'>>
) {
  const sessionData = readFromLocalStorage<SessionValues>({
    key: SESSION_KEY,
    defaultValue: DEFAULT_SESSION_VALUES,
  });
  writeToLocalStorage({
    key: SESSION_KEY,
    value: {
      ...sessionData,
      ...data,
    },
  });
}
